import { motion, useMotionValue } from 'framer-motion';
import React, { useCallback, useState } from 'react';
import { trackMixEvent, TRACK_EVENTS } from '../../services/analytics';
import Icon from '../../styled/Icon/Icon';
import BoxRenderer from '../BoxRenderer';
import {
  BoxViewerWrapper,
  ResizeableBox,
  ResizeableBoxHandle,
  CustomSizeWrapper,
} from './BoxViewer.styles';

interface BoxViewerProps {}

const getContainerSizeClass = (size: number) => {
  if (size < 400) return 'tk-size-mobile';
  if (size < 770) return 'tk-size-tablet';
  return 'tk-size-desktop';
};

const BoxViewer: React.FC<BoxViewerProps> = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [boxContainerClass, setboxContainerClass] = useState(
    getContainerSizeClass(window.innerWidth)
  );
  const boxWidth = useMotionValue(950);

  const handleDrag = useCallback(
    (_, info) => {
      const newWidth = boxWidth.get() + info.delta.x;
      if (newWidth > 350 && newWidth < 950) {
        boxWidth.set(newWidth);
      }
      setboxContainerClass(getContainerSizeClass(newWidth));
    },
    [boxWidth]
  );
  const handleSetCustomSize = (newWidth: number) => {
    // eslint-disable-next-line no-underscore-dangle
    trackMixEvent(TRACK_EVENTS.VIEW_CUSTOM_SIZE_ + newWidth);
    boxWidth.set(newWidth);
    setboxContainerClass(getContainerSizeClass(newWidth));
  };
  return (
    <>
      <BoxViewerWrapper>
        <ResizeableBox
          as={motion.div}
          style={{
            width: boxWidth,
            cursor: isDragging ? 'col-resize' : undefined,
          }}
          onDoubleClick={() => {
            boxWidth.set(950);
          }}
          className={boxContainerClass}
        >
          <BoxRenderer />
        </ResizeableBox>
        <ResizeableBoxHandle
          as={motion.div}
          drag="x"
          dragConstraints={{ top: 0, left: 0, right: 0, bottom: 0 }}
          dragElastic={0}
          dragMomentum={false}
          onDrag={handleDrag}
          onDragEnd={() => {
            setIsDragging(false);
          }}
          onDragStart={() => {
            setIsDragging(true);
          }}
        >
          <Icon type="dragHandle" height={33} width={10} />
        </ResizeableBoxHandle>
      </BoxViewerWrapper>
      <CustomSizeWrapper>
        <button type="button" onClick={() => handleSetCustomSize(375)}>
          <Icon type="device-mobile" />
        </button>
        {/* <button type="button" onClick={() => handleSetCustomSize(768)}>
          <Icon type="device-tablet" />
        </button> */}
        <button type="button" onClick={() => handleSetCustomSize(950)}>
          <Icon type="device-desktop" />
        </button>
        {/* <p>{boxWidth.get()}px</p> */}
      </CustomSizeWrapper>
    </>
  );
};

export default BoxViewer;
